import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { ToastrService } from 'ngx-toastr';
import { SportService } from '../services/sport.service';
@Component({
  selector: 'app-casino',
  templateUrl: './casino.component.html',
  styleUrls: ['./casino.component.scss']
})
export class CasinoComponent implements OnInit {
  tabActive:any='all'
  exchangeGameList: any;
  token: string;
  operator_id: string;
  games: string;
  activeTab:any="SN"
  sportList:any=[
    {
      code:"SN",
      name:"Super nova"
    },
    {
      code:"QT",
      name:"Qtech"
    },
    {
      code:"DC",
      name:"Dream Casino"
    },
    {
      code:"SPB",
      name:"SPRIBE"
    },
    {
      code:"GT",
      name:"Only Play"
    },
    {
      code:"SMTSG",
      name:"Smart Soft"
    },
    {
      code:"EVZ",
      name:"Evolution"
    },
    {
      code:"EZ",
      name:"Ezugi"
    },
  ]
  iUrl: any;

  constructor(private sport: SportService,private router: Router,private toastr:ToastrService) { }

  ngOnInit(): void {
    this.gotoexchangeGame(this.activeTab,this.tabActive);
  }
 
  gotoexchangeGame(cardData,type) {
    let data = {
      "providerCode":cardData
    }
    this.sport.getWCOGameList(data).subscribe((res) => {
      console.log(cardData,res.data)
      if(res.status == true){
        if(type=="all"){
          this.exchangeGameList=res.data
        }
        else{
          this.exchangeGameList = res.data.filter((val) => 
            new RegExp(type, "i").test(val.name)
          );
        }
       
      }
    })
  }
}
